import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Filters {
  searchQuery: string;
  sourceType: string | null;
  assignee: string;
  date: string | null;
  state: string | null;
  district: string | null;
  pincode: string | null;
  category: string | null;
}

const initialFilters: Filters = {
  searchQuery: "",
  sourceType: null,
  assignee: "",
  date: null,
  state: null,
  district: null,
  pincode: null,
  category: null,
};

const kanbanFilters = createSlice({
  name: "kanbanFilters",
  initialState: initialFilters,
  reducers: {
    setFilters(state, action: PayloadAction<Partial<Filters>>) {
      return { ...state, ...action.payload };
    },
    clearFilters() {
      return initialFilters;
    },
  },
});

export const { setFilters, clearFilters } = kanbanFilters.actions;
export default kanbanFilters.reducer;
